import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { ICurrentAssetsTableProps } from './types';
import { ProjectedBalanceFieldTable } from '../../../../components/ProjectedBalanceFieldTable';
import { assetsPrefix, FIRST_COLUMN_WIDTH } from '../../../../utils/form';
import {
  ASSETS_FORM_NAMES,
  CURRENT_ASSETS_TABLE_TOTAL_NAMES,
  useGetAssetsTotalRows,
  useGetCurrentAssetsVariants,
} from '../../utils/form';

export const CurrentAssetsTable: FC<ICurrentAssetsTableProps> = ({ disabled = false }) => {
  const period = useWatch({ name: GLOBAL_PERIOD_NAME });
  const { isExamplePage} = useExamplePreview()

  const { getValues } = useFormContext();
  const currentAssetsVariants = useGetCurrentAssetsVariants(isExamplePage);
  const { currentAssetsTotalRowTitle } = useGetAssetsTotalRows();

  const tableName = concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE);

  const totalName = concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.CURRENT_ASSETS_TABLE_TOTAL);

  const totalValues = getValues(totalName);

  const fields = getValues([
    concatWithDot(tableName, CURRENT_ASSETS_TABLE_TOTAL_NAMES.CASH_EQUIVALENTS),
    concatWithDot(tableName, CURRENT_ASSETS_TABLE_TOTAL_NAMES.SHORT_TERM_INVESTMENTS),
    concatWithDot(tableName, CURRENT_ASSETS_TABLE_TOTAL_NAMES.ACCOUNTS_RECEIVABLE),
    concatWithDot(tableName, CURRENT_ASSETS_TABLE_TOTAL_NAMES.INVENTORY),
    concatWithDot(tableName, CURRENT_ASSETS_TABLE_TOTAL_NAMES.PREPAID_EXPENSES),
    concatWithDot(tableName, CURRENT_ASSETS_TABLE_TOTAL_NAMES.OTHER_CURRENT_ASSETS),
  ]);

  return (
    <ProjectedBalanceFieldTable
      disabled={disabled}
      firstColumnWidth={FIRST_COLUMN_WIDTH}
      name={tableName}
      rows={fields}
      rowTitles={currentAssetsVariants}
      totalRowTitle={currentAssetsTotalRowTitle}
      totalName={totalName}
      period={period}
      totalValues={totalValues}
    />
  );
};
